module.exports = __webpack_public_path__ + "img/112.d3bd8c30.jpg";